export default __webpack_public_path__ + "forms.zh-cn.1762504472222.json";